module.exports = __webpack_public_path__ + "static/media/can-flag.eb946a72.png";